import enUS from './en'
import nbNO from './no'
export default {
  'en': enUS,
  'no': nbNO
}
